export default __webpack_public_path__ + "static/media/clear-text_padding.f861e9de.svg";